import { useState } from "react";
interface toastObj {
  id:number
  title: string,
  description: string,
  animationDelay?: number,
  deleteCallback:((id:number)=> void)
}
export default function useToast(){
  const [Toasts, setToasts] = useState<toastObj[]>([])
  console.log("called hook")
  function AddToast(
    id: number, title: string, description: string,
    deleteCallback: ((id: number) => void),
    animationDelay?: number,) {
    
    let ToastsArray = Toasts.slice()
    ToastsArray.push({
      id,title,description,animationDelay,deleteCallback
    })
    setToasts(ToastsArray)
  }
  function DeleteToast(id:number) {
    let filteredArr = Toasts.slice()
    filteredArr = filteredArr.filter((item) => {
      return item.id != id
    })
    console.log(filteredArr,id)
    setToasts(filteredArr)
  }
  return [
    Toasts,AddToast,DeleteToast
  ] as const
}
